import { render, staticRenderFns } from "./DashboardStatisticsView.vue?vue&type=template&id=676eb4a2&"
import script from "./DashboardStatisticsView.vue?vue&type=script&lang=js&"
export * from "./DashboardStatisticsView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardStatisticsView.vue?vue&type=style&index=0&id=676eb4a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports